module.exports = __webpack_public_path__ + "assets/images/clone.4069f5753e1fae34b6ee9f18aed3ad20.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/getting-started/clone.png
// module id = 1065
// module chunks = 0